const articles = [
  {
    img: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=900&q=80",
    date: "12 Mayıs 2024",
    title: "C2TEK ile HP Kiosk Çözümleri",
    desc: "Günümüz şirketleri, müşteri deneyimini geliştirerek rekabet avantajı elde etmek için yenilikçi teknolojilere yöneliyor. HP Kiosk Çözümleri tam da bu noktada devreye giriyor.",
  },
  {
    img: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&w=900&q=80",
    date: "5 Mayıs 2024",
    title: "Kurumsal Network Çözümleri Nedir?",
    desc: "Modern iş dünyasında şirketlerin rekabet gücünü artırmak, verimliliği yüksek tutmak ve müşteri memnuniyetini sağlamak güçlü bir ağ altyapısından geçiyor.",
  },
  {
    img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80",
    date: "28 Nisan 2024",
    title: "HP Operasyonel Kiralama Çözümü: Teknolojiye Erişimde Yeni Bir Yaklaşım",
    desc: "Modern şirketler teknolojik altyapılarını sürekli yenilemek zorundadır. Operasyonel kiralama, teknolojiye erişimde esnek ve sürdürülebilir bir alternatif sunuyor.",
  },
  {
    img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=900&q=80",
    date: "20 Nisan 2024",
    title: "HPE GreenLake Çözümü: Hibrit Bulutun Geleceği",
    desc: "Bulut teknolojileri, şirketlerin iş süreçlerini daha esnek ve verimli hale getiriyor. HPE GreenLake ile her şeyi hizmet olarak deneyimleyin.",
  },
];

export default function StoriesArticles() {
  return (
    <section className="bg-white py-20">
      <div className="container-x">
        {/* Başlık + CTA */}
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">
              Öğretici Makalelerimiz
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight text-ink sm:text-4xl lg:text-[2.5rem]">
              Uzmanlardan Güncel İçgörüler
            </h2>
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-muted lg:text-[17px]">
              Teknoloji trendleri, ipuçları ve sektör gelişmeleri hakkında güncel içerikler.
            </p>
          </div>
          <a
            href="#"
            className="hidden shrink-0 items-center gap-1.5 rounded-full border border-line px-4 py-2 text-sm font-semibold text-ink transition-colors hover:border-brand hover:text-brand sm:inline-flex"
          >
            <span>Tüm Makaleleri Gör</span>
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        {/* 4 makale — yan yana dikey kart */}
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {articles.map((a) => (
            <a
              key={a.title}
              href="#"
              className="group flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-soft transition-all hover:-translate-y-1 hover:border-brand/30 hover:shadow-card"
            >
              {/* Görsel - üstte */}
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={a.img}
                  alt={a.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* İçerik - altta */}
              <div className="flex flex-1 flex-col gap-2.5 p-6">
                <p className="flex items-center gap-1.5 text-xs font-medium text-muted">
                  <i className="ri-calendar-line text-sm"></i>
                  <span>{a.date}</span>
                </p>
                <h3 className="font-display text-lg font-bold leading-tight text-ink transition-colors group-hover:text-brand sm:text-xl">
                  {a.title}
                </h3>
                <p className="line-clamp-2 text-sm leading-relaxed text-muted">
                  {a.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-brand">
                  <span>Makaleyi Oku</span>
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
